export default __webpack_public_path__ + "static/media/sonnette.085f8155.svg";